// src/components/Loading.jsx
import React from "react";

const Loading = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      backgroundColor: "var(--color-background)",
    }}
  >
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          width: 48,
          height: 48,
          border: "3px solid var(--color-text-secondary)",
          borderTop: "3px solid var(--color-accent)",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
          margin: "0 auto 16px",
        }}
      />
      <p
        style={{
          fontFamily: "var(--font-family-serif)",
          color: "var(--color-accent)",
          fontSize: "1.1rem",
          letterSpacing: "0.05em",
        }}
      >
        Peaceful Oasis
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  </div>
);

export default Loading;
